import store from '@/store/panel'

import OrganisationsOverview from '@/vue/organisations/OrganisationsOverview.vue'
import OrganisationsRecord from '@/vue/organisations/OrganisationsRecord.vue'
import LogsOverview from '@/vue/logs/LogsOverview.vue'

// beforeEnter function
const ifAdmin = (to, from, next) => {
    let attempts = 0

    const checkAdmin = () => {
        if (typeof(store.state.user) != 'undefined' && store.state.user.role == 'pit') {
            next()
        } else if (attempts < 50) {
            attempts++
            setTimeout(checkAdmin, 100)
        } else {
            next({ name: 'Dashboard' })
        }
    };

    checkAdmin()
};

export default [
    {
        path: '/panel/organisaties',
        name: 'OrganisationsOverview',
        component: OrganisationsOverview,
        beforeEnter: ifAdmin,
    },
    {
        path: '/panel/organisaties/:id',
        name: 'OrganisationsRecord',
        component: OrganisationsRecord,
        beforeEnter: ifAdmin,
    },
    {
        path: '/panel/logs',
        name: 'LogsOverview',
        component: LogsOverview,
        beforeEnter: ifAdmin,
    }
]